import { formatDataCell } from '@/creditflowresearch/ui/components/deals/helpers';
import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import DealLeads from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/DealLeads';
import { LEAD_ROLE } from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/leadRoles';
import type ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

const TRANCHE_LEAD_FIELDS = [
  { field: 'leftLeads', role: LEAD_ROLE.left },
  { field: 'billingDelivering', role: LEAD_ROLE.billingDelivering },
  { field: 'activeLeads', role: LEAD_ROLE.active },
  { field: 'jointLeads', role: LEAD_ROLE.joint },
  { field: 'passiveLeads', role: LEAD_ROLE.passive },
  { field: 'coManagers', role: LEAD_ROLE.coManager },
  { field: 'coordinatingManagers', role: LEAD_ROLE.coordinatingManager },
] as const;

interface ITrancheLeadProps {
  tranche: ITranch,
  role: string,
}

/**
 * One tranche field shows the banks of its own role; its tooltip shows the whole tranche syndicate.
 */
export const TrancheLead = ({ tranche, role }: ITrancheLeadProps) => {
  const { deal } = useDealPageContext();
  const cellField = TRANCHE_LEAD_FIELDS.find((lead) => lead.role === role)?.field;

  if (!cellField || !tranche[cellField]?.length) {
    return formatDataCell(null);
  }

  const groups = TRANCHE_LEAD_FIELDS.map(({ field, role: fieldRole }) => ({ role: fieldRole, leads: tranche[field] }));

  return (
    <DealLeads
      groups={ groups }
      inlineRoles={ [role] }
      fallbackQuery={ { products: deal.product?.abbreviation, regions: deal.country?.region?.abbreviation } }
    />
  );
};
